import React from 'react';

import calculatorIcon from '../../images/FinancialTools/calculator.svg';
import fileIcon from '../../images/FinancialTools/file.svg';
import howmuchIcon from '../../images/FinancialTools/howmuch.svg';

import style from './FinancialTools.scss';

import cn from 'classnames';
import { Link } from 'gatsby';

export interface IFinancialToolsProps {
  className?: string;
}

export const FinancialTools = (props: IFinancialToolsProps) => {
  return (
    <div className={cn(style.financialTools, props.className)}>
      <h3>Financial Tools</h3>
      <Link to="/retirement-calculator/" className={style.base}>
        <img width="36" height="36" src={calculatorIcon} alt="Image" />
        <div>
          <h4>Retirement calculator: How much do I really need to retire?</h4>
        </div>
      </Link>
      <Link to="/how-to-invest/" className={style.base}>
        <img width="36" height="36" src={howmuchIcon} alt="Image" />
        <div>
          <h4>How to invest when you feel like you're behind</h4>
        </div>
      </Link>
      <Link to="/millennial-retirement-plan/" className={style.base}>
        <img width="36" height="36" src={fileIcon} alt="Image" />
        <div>
          <h4>The millennial retirement plan so crazy it just might work</h4>
        </div>
      </Link>
    </div>
  );
};
